import { render, staticRenderFns } from "./EntryStatus.vue?vue&type=template&id=12cd79a0&scoped=true&"
import script from "./EntryStatus.vue?vue&type=script&lang=ts&"
export * from "./EntryStatus.vue?vue&type=script&lang=ts&"
import style0 from "./EntryStatus.vue?vue&type=style&index=0&id=12cd79a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cd79a0",
  null
  
)

export default component.exports